'use client'

import { useRouter } from 'next/navigation'
import { ReactNode } from 'react'
import { MdChevronRight, MdMenu } from 'react-icons/md'

import Button from '../shared/button'

import { HelpCenter } from '@/components'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { useAppSelector } from '@/libs/hooks/use-app-selector'
import { toggleSidebar } from '@/libs/store/slice/ui-slice'

export default function AuthNavbar({
  appLogo,
  showLoginBtn = false,
  showMenu = false,
}: Readonly<{ appLogo: ReactNode; showLoginBtn?: boolean; showMenu?: boolean }>) {
  const { push } = useRouter()

  const dispatch = useAppDispatch()
  const { showSidebar } = useAppSelector((state) => state.ui)

  const toggleMenu = () => dispatch(toggleSidebar(!showSidebar))

  return (
    <nav className='sticky top-0 z-10 w-full bg-white' id='header'>
      <div className='flex h-[90px] w-full flex-1 flex-row items-center justify-between p-5 md:px-12 md:py-6 lg:mx-auto lg:px-16 xl:px-36'>
        {appLogo}
        <div className='flex flex-row items-center gap-4'>
          <HelpCenter />
          {showMenu && (
            <button onClick={toggleMenu} data-testid='hamburger-menu' className='w-full'>
              <MdMenu className='h-7 !w-7 cursor-pointer text-pop-grey-900' />
            </button>
          )}
          {showLoginBtn && (
            <Button
              type='button'
              variant='text'
              color='primary'
              onClick={() => push('/auth/login')}
              aria-label='Go to Log in'
            >
              <div className='flex min-w-7 flex-row items-center justify-center gap-1'>
                <MdChevronRight className='h-5 w-5 text-pop-blue-700' />
                <span className='hidden lg:block'>Back to Login</span>
              </div>
            </Button>
          )}
        </div>
      </div>
    </nav>
  )
}
